module.exports = __webpack_public_path__ + "img/DE00467.01e75158.png";